/* HIT posts API ENDPOINT */

import Api from '@/services/Api'

export default {
  getItems () {
    return Api().get('menu/items')
  },
  getItem () {
    return Api().get('menu/items/:id')
  },
  getItemById (id) {
    return Api().get(`menu/items/${id}`)
  },
  getItemByVariantId (id) {
    return Api().post('menu/items/variant/', id)
  },
  deleteItem (item) {
    return Api().delete('menu/edit/items/:item', { data: item })
  },
  addItem (item) {
    return Api().post('menu/edit/items/', item)
  },
  updateItem (item) {
    return Api().put('menu/edit/items/:item', item)
  }
}



// WEBPACK FOOTER //
// ./src/services/ItemsService.js